import React, { useEffect } from "react"
import Signup from "./Signup"
import { AuthProvider } from "../contexts/AuthContext"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import Dashboard from "./Dashboard"
import Login from "./Login"
import PrivateRoute from "../Routes/PrivateRoute"
import ForgotPassword from "./ForgotPassword"
import Settings from "./Settings"
import LeftsideNavbar from "./Navigationbars/LeftsideNavbar"
import Users from "./Users"
import { AdminLog } from "../Leadtubadmin/Views/AdminLog";
import ContactUs from "./ContacsUs"
import Leads from "./Leads"
import LeadDetails from "./Leaddetails"
import Accountdetails from "./Accountdetails"
import '../style/componentstyles.css'
import Quote from "./Quote";
import Archive from "./Archive";
import { AdminLeadDetails } from '../Leadtubadmin/Components/AdminLeads/AdminLeadDetails'
import useWindowDimensions from "../services/useWindowDimensions";
import MobileNavBar from "./MobileNavBar";
import { CompanyDetails } from "./CompanyDetails";
import { AdminDashboard } from "../Leadtubadmin/Views/AdminDashboard";
import { AdminCompanyDetailsDashboard } from "../Leadtubadmin/Views/AdminCompanyDetailsDashboard";
import { AdminOnboardDashboard } from "../Leadtubadmin/Views/AdminOnboardDashboard";
import { AdminUserDashboard } from "../Leadtubadmin/Components/AdminUserDashboard"
import { AdminUserDetails } from "../Leadtubadmin/Components/AdminUsers/AdminUserDetails";
import { AdminCompanyDashboard } from "../Leadtubadmin/Components/AdminCompany/AdminCompanyDashboard";
import { AdminLeadDashBoard } from "../Leadtubadmin/Components/AdminLeads/AdminLeadDashBoard"
import { AdminApp } from "../Leadtubadmin/Components/AdminApp/AdminApp";
import { ConsentPage } from "./consent/Consent"

function App() {

    const { height, width } = useWindowDimensions();


    useEffect(() => {
        document.title = "LeadtubAdmin"
    }, [])


    return (
        <React.Fragment>
            <Router>
                <AuthProvider>
                    {width > 600 ? (
                        <LeftsideNavbar />
                    ) : (
                        <MobileNavBar />
                    )}

                    <Switch>
                        <PrivateRoute exact path="/" component={Dashboard} />
                        <PrivateRoute exact path="/dashboard" component={Dashboard} />
                        {/* updateprofile är settingsscreen */}
                        <PrivateRoute exact path="/leads" component={Leads} />
                        <PrivateRoute exact path="/lead/:id" component={LeadDetails} />
                        <PrivateRoute exact path="/lead/:id/quote" component={Quote} />
                        <PrivateRoute path="/companydetails/:id" component={CompanyDetails} />
                        <PrivateRoute exact path="/accountdetails/:id" component={Accountdetails} />
                        <PrivateRoute exact path="/leadtub-admin-dashboard" component={AdminDashboard} />
                        {/*
                        <PrivateRoute exact path="/leadtub-admin-companies" component={AdminCompanyDetailsDashboard}/>
                        */}

                        <PrivateRoute exact path="/leadtub-admin-onboard" component={AdminOnboardDashboard} />
                        <PrivateRoute exact path="/leadtub-admin-company/:id" component={AdminCompanyDetailsDashboard} />
                        <PrivateRoute exact path="/leadtub-admin-user-details/:id" component={AdminUserDetails} />
                        <PrivateRoute exact path="/leadtub-admin-lead-details/:id" component={AdminLeadDetails} />
                        <PrivateRoute exact path="/leadtub-admin-log" component={AdminLog} />
                        <PrivateRoute exact path="/archive" component={Archive} />
                        <PrivateRoute exact path="/leads" component={Leads} />
                        <PrivateRoute exact path="/lead/:id" component={LeadDetails} />
                        <PrivateRoute exact path="/lead/:id/quote" component={Quote} />
                        <PrivateRoute path="/users" component={Users} />
                        <PrivateRoute path="/companydetails/:id" component={CompanyDetails} />
                        <PrivateRoute path="/settings" component={Settings} />


                        <PrivateRoute path="/contact-us" component={ContactUs} />
                        <PrivateRoute exact path="/accountdetails/:id" component={Accountdetails} />
                        <PrivateRoute exact path="/leadtub-admin-dashboard" component={AdminDashboard} />
                        <PrivateRoute exact path="/leadtub-admin-companies" component={AdminCompanyDashboard} />
                        <PrivateRoute exact path="/leadtub-admin-onboard" component={AdminOnboardDashboard} />
                        <PrivateRoute exact path="/leadtub-admin-leads" component={AdminLeadDashBoard} />
                        <PrivateRoute exact path="/leadtub-admin-company/:id" component={AdminCompanyDetailsDashboard} />
                        <PrivateRoute exact path="/leadtub-admin-user-details/:id" component={AdminUserDetails} />
                        <PrivateRoute exact path="/leadtub-admin-users" component={AdminUserDashboard} />
                        <PrivateRoute exact path="/leadtub-admin-app" component={AdminApp} />

                        <PrivateRoute exact path="/leadtub-admin-lead-details/:id" component={AdminLeadDetails} />
                        <PrivateRoute exact path="/leadtub-admin-log" component={AdminLog} />
                        <PrivateRoute exact path="/archive" component={Archive} />

                        <Route path="/signup" component={Signup} />
                        <Route path="/consent" component={ConsentPage} />
                        <Route path="/login" component={Login} />
                        <Route path="/forgot-password" component={ForgotPassword} />
                    </Switch>

                </AuthProvider>
            </Router>

        </React.Fragment>
    )
}

export default App;
